/**
 * Created by Yangxunwu on 2018/6/21.
 */
import { uploadSalaryRecord, getSalaryRecordDetail } from '@/api/salary'

const salary = {

    state: {
	    headerFields: [],       //隐藏字段
        staffNameField: '',     //员工名称字段
        realSalaryField: '',    //实发工资字段
        recordData: {},         //工资记录数据
	    recordDataTotal: 0,     //工资记录数量
    },

    mutations: {

        SET_RECORD_DATA: (state, recordData) => {
            state.recordData = recordData
        },

	    SET_RECORD_DATA_TOTAL: (state, recordDataTotal) => {
		    state.recordDataTotal = recordDataTotal
	    },

        SET_RECORD_HEADER_FIELD: (state, headerFields) => {
            state.headerFields = headerFields
        },

        SET_STAFF_NAME: (state, staffNameField) => {
            state.staffNameField = staffNameField;
        },

	    SET_REAL_SALARY: (state, realSalaryField) => {
		    state.realSalaryField = realSalaryField;
	    },

    },

    actions: {

        GetSalaryRecordData({ commit }, recordId) {

            return new Promise((resolve, reject) => {

                getSalaryRecordDetail(recordId).then(response => {

                    const data = response.data;

                    commit("SET_RECORD_DATA", data.data);
                    commit("SET_RECORD_HEADER_FIELD", data.headerFields);
                    commit("SET_RECORD_DATA_TOTAL", data.total);

                    resolve(response);
                }).catch(error => {
                    reject(error);
                })
            })
        },


    }
}

export default salary



// WEBPACK FOOTER //
// ./src/store/modules/salary.js